import { IAction } from "../utils";
import { reducerTypes } from "./types";
import { IPageInfo } from "../../interfaces/common";
import { IServiceOrder } from "../../interfaces/serviceOrder";

export interface IServiceOrderReducer {
  pageInfo: IPageInfo;
  serviceOrders: IServiceOrder[];
  serviceOrdersMore: IServiceOrder[];
  serviceOrder?: IServiceOrder;
  loading: boolean;
}

export const INITIAL: IServiceOrderReducer = {
  pageInfo: {
    pageIndex: -1,
    totalPages: 0,
    totalCount: 0,
    pageSize: 12,
  },
  serviceOrders: [],
  serviceOrdersMore: [],
  loading: false,
};

export const serviceOrderReducer = (state = INITIAL, { type, payload }: IAction) => {
  switch (type) {
    case reducerTypes.IS_LOADING:
      return { ...state, loading: payload };
    case reducerTypes.GET_ALL_SERVICEORDERS:
      return {
        ...state,
        serviceOrders: payload,
        serviceOrdersMore: payload,
        loading: false,
      };
    case reducerTypes.GET_MORE_SERVICEORDERS:
      return {
        ...state,
        serviceOrdersMore: [...state.serviceOrdersMore, ...payload],
        loading: false,
      };
    case reducerTypes.GET_SERVICEORDER:
      return { ...state, serviceOrder: payload };
    case reducerTypes.SET_PAGE_INFO:
      return { ...state, pageInfo: payload };
    case reducerTypes.SET_PAGE_INDEX:
      return { ...state, pageInfo: { ...state.pageInfo, pageIndex: payload } };
    case reducerTypes.SET_PAGE_SIZE:
      return { ...state, pageInfo: { ...state.pageInfo, pageSize: payload } };
    default:
      return state;
  }
};
